import { useEffect } from 'react';
import SaveAlertModal from './SaveAlertModal.component';
import SavePanelModal from './SavePanelModal.component';
import { useActionModal } from '../../hooks/ActionModal.hook';
import { useCurrentConfiguration } from '../../hooks/CurrentConfiguration.hook';
import { useCheckDuplicatePanelLazyQuery, CheckDuplicatePanelQueryVariables, PlugRegion, PanelWidth } from '../../lib/graphql.generated';

export default function SavePanel() {
  const { configuration } = useCurrentConfiguration();
  const { savePanel: { isOpen } } = useActionModal();

  const [checkForDuplicates, {
    loading,
    data,
  }] = useCheckDuplicatePanelLazyQuery({
    fetchPolicy: 'network-only',
  });

  console.log('data', data);
  console.log('loading', loading);

  useEffect(() => {
    if (isOpen) {
      const checkPanel: CheckDuplicatePanelQueryVariables = {
        width: configuration?.width ?? PanelWidth.Small,
        plugRegion: configuration?.plugRegion ?? PlugRegion.Schuko,
        components: configuration?.components.map((i) => i.id) ?? [],
      };
      checkForDuplicates({ variables: checkPanel });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  // Don't render anything if modal is not open
  if (!isOpen) {
    return null;
  }

  // If we have data and it indicates a duplicate, show the alert modal
  if (data && data?.duplicateConfiguration?.id) {
    return <SaveAlertModal id={data?.duplicateConfiguration?.id} />;
  }

  // If we have data and no duplicate, or if we're still loading, show the save modal
  return <SavePanelModal />;
}